import React from 'react';
import { motion } from 'framer-motion';
import { FaGithub, FaLinkedin, FaEnvelope } from 'react-icons/fa';

const Footer = () => {
  const scrollToSection = (sectionId) => {
    const element = document.getElementById(sectionId);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  const navigationLinks = [
    { id: 'home', label: 'Home' },
    { id: 'about', label: 'About' },
    { id: 'skills', label: 'Skills' },
    { id: 'projects', label: 'Projects' },
    { id: 'contact', label: 'Contact' },
  ];

  const connectLinks = [
    { icon: FaGithub, href: 'https://github.com/Sumeshstha', label: 'GitHub' },
    { icon: FaLinkedin, href: 'https://www.linkedin.com/in/sumesh-shrestha-838822273/', label: 'LinkedIn' },
    { icon: FaEnvelope, href: 'mailto:sumeshstha94@gmail.com', label: 'Email' },
  ];

  const skillLinks = [
    'Web Development',
    'Cloud Computing',
    'Networking'
  ];

  return (
    <footer className="bg-light-footer dark:bg-dark-footer text-white py-12 sm:py-16">
      <div className="max-w-7xl mx-auto px-5 sm:px-6 lg:px-8">
        {/* Main Footer Content */}
        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-6 sm:gap-8 mb-10 sm:mb-12">
          {/* Navigation Column */}
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.5 }}
            viewport={{ once: true }}
          >
            <h3 className="text-lg font-bold mb-4">Navigation</h3>
            <ul className="space-y-2">
              {navigationLinks.map((link) => (
                <li key={link.id}>
                  <motion.button
                    whileHover={{ x: 5 }}
                    onClick={() => scrollToSection(link.id)}
                    className="text-gray-300 hover:text-white transition-colors duration-300 text-left"
                  >
                    {link.label}
                  </motion.button>
                </li>
              ))}
            </ul>
          </motion.div>

          {/* Connect Column */}
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.5, delay: 0.1 }}
            viewport={{ once: true }}
          >
            <h3 className="text-lg font-bold mb-4">Connect</h3>
            <ul className="space-y-2">
              {connectLinks.map((link) => (
                <li key={link.label}>
                  <motion.a
                    href={link.href}
                    {...(link.href.startsWith('mailto:') ? {} : { target: "_blank", rel: "noopener noreferrer" })}
                    whileHover={{ x: 5 }}
                    className="text-gray-300 hover:text-white transition-colors duration-300 flex items-center gap-2"
                  >
                    <link.icon className="w-4 h-4" />
                    {link.label}
                  </motion.a>
                </li>
              ))}
            </ul>
          </motion.div>

          {/* Skills Column */}
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.5, delay: 0.2 }}
            viewport={{ once: true }}
          >
            <h3 className="text-lg font-bold mb-4">Skills</h3>
            <ul className="space-y-2">
              {skillLinks.map((skill) => (
                <li key={skill}>
                  <span className="text-gray-300 hover:text-white transition-colors duration-300 cursor-pointer">
                    {skill}
                  </span>
                </li>
              ))}
            </ul>
          </motion.div>

          {/* CTA Column */}
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.5, delay: 0.3 }}
            viewport={{ once: true }}
            className="lg:col-span-1"
          >
            <h3 className="text-lg font-bold mb-4">Ready to work together?</h3>
            <p className="text-gray-300 mb-6">
              Get in touch!
            </p>
            <div className="flex gap-4">
              {connectLinks.map((link) => (
                <motion.a
                  key={link.label}
                  href={link.href}
                  {...(link.href.startsWith('mailto:') ? {} : { target: "_blank", rel: "noopener noreferrer" })}
                  whileHover={{ scale: 1.1, y: -2 }}
                  whileTap={{ scale: 0.9 }}
                  className="w-10 h-10 bg-gray-700 hover:bg-light-primary dark:hover:bg-dark-primary rounded-full flex items-center justify-center transition-colors duration-300"
                >
                  <link.icon className="w-5 h-5" />
                </motion.a>
              ))}
            </div>
          </motion.div>
        </div>

        {/* Bottom Border */}
        <div className="border-t border-gray-600 pt-8">
          <div className="flex flex-col md:flex-row justify-between items-center">
            {/* Copyright */}
            <motion.div
              initial={{ opacity: 0 }}
              whileInView={{ opacity: 1 }}
              transition={{ duration: 0.5 }}
              viewport={{ once: true }}
              className="text-gray-300 mb-4 md:mb-0"
            >
              <p className="flex items-center gap-2">
                © 2024 Sumesh Shrestha.
              </p>
            </motion.div>

            {/* Additional Links */}
            <motion.div
              initial={{ opacity: 0 }}
              whileInView={{ opacity: 1 }}
              transition={{ duration: 0.5, delay: 0.1 }}
              viewport={{ once: true }}
              className="flex gap-6 text-sm"
            >
              {/* <button className="text-gray-300 hover:text-white transition-colors duration-300">
                Privacy Policy
              </button>
              <button className="text-gray-300 hover:text-white transition-colors duration-300">
                Terms of Service
              </button> */}
            </motion.div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;